import {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

interface IPanelPopoverContext {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    close: () => void;
}

const PanelPopoverContext = createContext<IPanelPopoverContext | undefined>(undefined);

const usePanelPopoverContext = () => {
    const context = useContext(PanelPopoverContext);
    if (!context) {
        throw new Error('usePanelPopoverContext must be used within a PanelPopoverProvider');
    }
    return context;
};

const PanelPopoverProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const close = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);

    const value = useMemo(
        () => ({
            isOpen,
            close,
            setIsOpen,
        }),
        [isOpen, close, setIsOpen],
    );

    return <PanelPopoverContext.Provider value={value}>{children}</PanelPopoverContext.Provider>;
};

export { usePanelPopoverContext, PanelPopoverProvider };
